import { render } from "./AposImageWidget.vue?vue&type=template&id=24a1a422&scoped=true"
import script from "./AposImageWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./AposImageWidget.vue?vue&type=script&setup=true&lang=js"

import "./AposImageWidget.vue?vue&type=style&index=0&id=24a1a422&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a1a422"],['__file',"image-widget/ui/apos/components/AposImageWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24a1a422"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24a1a422', __exports__)) {
    api.reload('24a1a422', __exports__)
  }
  
  module.hot.accept("./AposImageWidget.vue?vue&type=template&id=24a1a422&scoped=true", () => {
    api.rerender('24a1a422', render)
  })

}


export default __exports__